<template>
	<div>
		<!--工具条-->
		<el-col :span="24" class="toolbar uptool" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-input v-model="inputMac" placeholder="请输入Mac地址" prefix-icon="el-icon-search" size="small"></el-input>
				</el-form-item>
				<el-form-item>
				<el-date-picker v-model="Time" size="small" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
    			</el-form-item>
				<el-form-item>
					<!--<el-button type="primary" size="small" @click="Find">查询</el-button>-->
					<el-button type="primary" size="small" @click="BeforeFind" icon="el-icon-search">搜索</el-button>
				</el-form-item>
				<el-form-item style="float: right;">
					<el-button type="primary" plain size="small" @click="Refresh">刷新</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		
		<el-table :data="List" border v-loading="listloading" style="width: 100%" :max-height="maxHeight">
		    <el-table-column fixed label="设备Mac地址" prop="mac" width="150"></el-table-column>
			<el-table-column label="开机时长" width="150">
				<template slot-scope="scope">
					<span>{{timeformat(scope.row.f1)}}</span>
				</template>
			</el-table-column>
			<el-table-column label="左电机使用时长" width="150">
				<template slot-scope="scope">
					<span>{{timeformat(scope.row.f2)}}</span>
				</template>
			</el-table-column>
			<el-table-column label="右电机使用时长" width="150">
				<template slot-scope="scope">
					<span>{{timeformat(scope.row.f3)}}</span>
				</template>
			</el-table-column>
			<el-table-column label="座椅电机使用时长" width="150">
				<template slot-scope="scope">
					<span>{{timeformat(scope.row.f4)}}</span>
				</template>
			</el-table-column>
			<el-table-column label="按键使用次数" width="150">
				<template slot-scope="scope">
					<span>{{scope.row.f5}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="机器运行行程" width="150">
				<template slot-scope="scope">
					<span>{{scope.row.f6}} 米</span>
				</template>
			</el-table-column>
			<el-table-column label="开关机次数" width="150">
				<template slot-scope="scope">
					<span>{{scope.row.f7}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="can485网关丢失次数" width="120">
				<template slot-scope="scope">
					<span>{{scope.row.f8}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="can下控丢失次数" width="150">
				<template slot-scope="scope">
					<span>{{scope.row.f9}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="can驱动器丢失次数" width="110">
				<template slot-scope="scope">
					<span>{{scope.row.f10}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="LED丢失次数" width="150">
				<template slot-scope="scope">
					<span>{{scope.row.f11}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="MPU6050丢失次数" width="110">
				<template slot-scope="scope">
					<span>{{scope.row.f12}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="压力传感器丢失次数" width="110">
				<template slot-scope="scope">
					<span>{{scope.row.f13}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="久站提醒次数" width="150">
				<template slot-scope="scope">
					<span>{{scope.row.f14}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="急转提醒次数" width="150">
				<template slot-scope="scope">
					<span>{{scope.row.f15}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="颠簸提醒次数" width="150">
				<template slot-scope="scope">
					<span>{{scope.row.f16}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="倾斜提醒次数" width="150">
				<template slot-scope="scope">
					<span>{{scope.row.f17}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="镇江驱动器报错次数" width="110">
				<template slot-scope="scope">
					<span>{{scope.row.f18}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="摆臂切换次数" width="150">
				<template slot-scope="scope">
					<span>{{scope.row.f19}} 次</span>
				</template>
			</el-table-column>
			
			
			
			<el-table-column fixed="right" label="时间" prop="time" width="180" :formatter="dateFormat"></el-table-column>
  		</el-table>
  		
  		<!--工具条-->
  		<el-col :span="24" class="toolbar downtool">
			<el-pagination layout="prev, pager, next,jumper" @current-change="handleCurrentChange" :page-size="Pagesize" :current-page="Curpage" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
	</div>
</template>

<script>
	import {GetDevflashlogslist} from '../api/api';
	
	export default {
		data(){
			return {
				token:"",
				maxHeight:600,
				Time:"",
				listloading:false,
				total:1,
				Curpage:1,
				Pagesize:20,
				List:[],
				Findform:"",
				inputMac:""
			}
		},
		methods:{
			timeformat(val){
				return val + "秒"
//				var mint = Math.round(val/60)%60
//				var hour = (Math.round(val/60) - Math.round(val/60)%60)/60
//				if(mint == 0 && hour == 0){
//					return 0 + "分钟"
//				}else if(hour == 0){
//					return mint + "分钟"
//				}else if(mint == 0 ){
//					return hour + "小时"
//				}else{
//					return hour + "小时" + mint + "分钟"
//				}
			},
			handleCurrentChange(val){
				this.Curpage = val
				this.Find()
			},
			BeforeFind(){
				this.Curpage = 1
				this.Find()
			},
			Find(){
				if(this.Time){
					this.Betweenall = {"BETWEEN":{'time':[this.Time[0]/1000,this.Time[1]/1000]}}
				}else{
					this.Betweenall = {"BETWEEN":{}}
				}
				if(this.inputMac){
					this.Screenall = {"AND":{'mac':'~' + this.inputMac}}
				}else{
					this.Screenall = {"AND":{}}
				}
				var ever = [this.Screenall,this.Betweenall]
				var ever2 = JSON.stringify(ever)
				if(this.Screenall || this.Betweenall){
					this.GetList(GetDevflashlogslist,{page:this.Curpage,token:this.token,sort:"-time",q:ever2})
				}else{
					this.GetList(GetDevflashlogslist,{page:this.Curpage,token:this.token,sort:"-time"})
				}
			},
			Refresh(){
				this.Time = ""
				this.inputMac = ""
				this.Curpage = 1
				this.GetList(GetDevflashlogslist,{page:this.Curpage,token:this.token,sort:"-time"})
			}
	},
		created(){
			this.token = sessionStorage.getItem("BBRtoken");
			this.GetList(GetDevflashlogslist,{page:this.Curpage,token:this.token,sort:"-time"})
		},
		mounted(){
			this.$nextTick(function(){
				this.Gethigh()
			})
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// EquipmentFlash.vue?a70b3054